import { Reducer } from "redux";

import { MasterMfaPreferenceResponse } from "../models/api/MyAccount";
import { MasterMfaPreferenceDispatchTypes } from "../models/dispatchTypes/MyAccount";
import { MfaPreferenceActionDispatchTypes } from "../constants/MyAccount";

const initialState: MasterMfaPreferenceResponse = {
  loading: false,
  response: [],
};

const MasterMfaPreferenceReducer: Reducer<
  MasterMfaPreferenceResponse,
  MasterMfaPreferenceDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MfaPreferenceActionDispatchTypes.MASTER_MFA_PREFERENCE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MfaPreferenceActionDispatchTypes.MASTER_MFA_PREFERENCE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default MasterMfaPreferenceReducer;
